import SeoHead from "@/components/SeoHead";
import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <SeoHead
        title="Page non trouvée | Carreaux-Bat Valais"
        description="La page demandée n'existe pas. Retournez à l'accueil ou contactez Carreaux-Bat Valais pour un devis de carrelage."
        canonical="https://carreaux-bat.ch"
      />
      <div className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0" aria-hidden="true">
        404
      </div>
      <div className="relative z-10">
        <h2 className="text-xl md:text-2xl font-semibold mt-6">Cette page n&apos;existe pas</h2>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">La page demandée n&apos;a pas été trouvée</p>
      </div>
    </div>
  );
}